import { AxiosCalls } from './Functions/AxiosCalls';
import { handleDefaultApiErrors } from 'Utils/Global/apiErrorHandling';
import type {
  IPaymentMethodView,
  IPaymentMethodsResponse,
  IHandleGetPaymentMethodsParams,
  ComputeSelectedPaymentMethodParams,
} from '@model/PaymentMethod.model';

export class PaymentMethodService {
  async handleGetPaymentMethods({
    setLoading,
    setApiError,
    setItems,
    setTotal,
    token,
    onAuthError,
    onForbidden,
  }: IHandleGetPaymentMethodsParams): Promise<void> {
    setLoading(true);
    setApiError(null);

    try {
      const resp = await AxiosCalls.Get<IPaymentMethodsResponse>(
        '/payment-methods/getPayments',
        token
      );

      const payload = resp?.data ?? {};
      const items: IPaymentMethodView[] = payload?.data?.items ?? [];
      setItems(items);

      const total = typeof payload?.meta?.total === 'number' ? payload.meta.total : items.length;

      if (setTotal) setTotal(total);
    } catch (err) {
      const msg = handleDefaultApiErrors(err, {
        hadToken: Boolean(token),
        onAuthError,
        onForbidden,
      });

      setApiError(msg);
      setItems([]);
      if (setTotal) setTotal(0);
    } finally {
      setLoading(false);
    }
  }
  computeSelectedMethod({
    availableMethods,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
  }: ComputeSelectedPaymentMethodParams): IPaymentMethodView | null {
    const methods = availableMethods ?? [];

    if (!methods.length) {
      if (selectedPaymentMethod) setSelectedPaymentMethod(null);
      return null;
    }

    const selectedId = selectedPaymentMethod?.id ?? '';
    const isSelectedStillAvailable = selectedId !== '' && methods.some((m) => m.id === selectedId);

    const resolvedMethod = isSelectedStillAvailable ? selectedPaymentMethod : methods[0];

    if (resolvedMethod?.id !== selectedPaymentMethod?.id) {
      setSelectedPaymentMethod(resolvedMethod);
    }

    return resolvedMethod;
  }
}
